import ClinentFindList from "./ClinentFindList";

export default ClinentFindList;